module.exports = __webpack_public_path__ + "images/lightning2-mobile.jpg";